<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->


  $(function () {

    // let myInterval = setInterval(()=>{
    //   if($('.header-item .search_details.search_details--popup').attr('open') === 'open'){
    //     $('.header-item .search_details.search_details--popup').removeAttr('open')
    //     clearInterval(myInterval);
    //   }
    // },10)

  let $circle = $('.shopTheLook');
  let $info = $('.product_box_container .product_box');

  $(document).on('click', '.shopTheLook', function(){
    $(this).parent().find('.product_box_container').css('display','block');
    console.log($(this).parents('.under_ss'))
    $(this).parents('.under_ss').find('.slick-prev.pull-left').css('z-index','0')
    // css('display','block')
  })

  $(document).on('click', '.shopTheLook2', function(){
    $(this).parent().find('.product_box_container2').css('display','block');
    console.log($(this).parents('.under_ss'))
    $(this).parents('.under_ss').find('.slick-prev.pull-left').css('z-index','0')
    // css('display','block')
  })

  $(document).on('click','.close_btn', function() {
        // console.log($(this).parents('.product_box_container'));
    let thiss = $(this)
    setTimeout(()=>{
      thiss.parent().css('display','none');
      $(this).parents('.under_ss').find('.slick-prev.pull-left').css('z-index','1')
    },100)
        
    });

  $(document).on('click','.close_btn2', function() {
        // console.log($(this).parents('.product_box_container'));
    let thiss = $(this)
    setTimeout(()=>{
      thiss.parent().css('display','none');
      $(this).parents('.under_ss').find('.slick-prev.pull-left').css('z-index','1')
    },100)
        
    });
  
  // $circle.click(
  //     function () {
  //       // var circleOffset = $circle.offset();
  //       console.log('this: ',$(this))
  //       var circleOffset = $(this).position().top;
  //       var circleOffsetLeft = $(this).position().left;
  //       var circleHeight = $(this).height();

  //       // Position the info container below the circle
  //       if(circleOffset > 200 && circleOffsetLeft > 200){
  //         $info.css({
  //           bottom: 8,
  //           right: 8,
  //           top: 'unset'
  //         });
  //       }else if(circleOffset <= 200 && circleOffsetLeft > 200){
  //         $info.css({
  //           top: 8,
  //           right: 8,
  //           bottom: 'unset'
  //         });
  //       }else if(circleOffset >= 200 && circleOffsetLeft <= 200){
  //         $info.css({
  //           top: 8,
  //           left: 8,
  //           bottom: 'unset'
  //         });
  //       } else{
  //         $info.css({
  //           top: 8,
  //           left: 8,
  //           bottom: 'unset'
  //         });
  //       }
        

  //       // $info.fadeIn();
  //       $(this).parent().find(".product_box_container").show();
  //     },
  //     function () {
  //       // $info.fadeOut();
  //       $(".product_box_container").hide();
  //     }
  //   );


if (window.matchMedia("(max-width: 700px)").matches) {
  $(".slider-together-card").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
  });
  $(".prev-button").click(function () {
    $(".slider-together-card").slick("slickPrev");
  });

  $(".next-button").click(function () {
    $(".slider-together-card").slick("slickNext");
  });
}
$(".slider-together-card").slick({
  slidesToShow: 4,
  slidesToScroll: 1,
});

$(".prev-button").click(function () {
  $(".slider-together-card").slick("slickPrev");
});

$(".next-button").click(function () {
  $(".slider-together-card").slick("slickNext");
});


    
// $(document).on('click','.header-item .search_details.search_details--popup',function(){
//   console.log("herer!!")
//     $(this).attr('open','open')
// })
  let langHtml = '<aside data-wg-notranslate="true" aria-label="Language selected: English" class="my-wg-drop weglot_switcher wg-mouse-click country-selector default closed wg-drop"><div data-l="en" role="combobox" aria-activedescendant="" aria-label="Language" tabindex="0" aria-expanded="false" aria-controls="weglot-listbox" class="wg-li en wg-flags"><a target="_self" href="javascript:void(0)" id="weglot-language" tabindex="-1"><img src="https://cdn.weglot.com/flags/circle/gb.svg" width="24" height="24" role="none" alt="English flag" class="wg-flag"></a></div><ul role="listbox" id="weglot-listbox" style="display: none;"><li data-l="nl" role="none" id="wg-nl" class="wg-li nl wg-flags"><a role="option" href="javascript:void(0)" id="weglot-language-nl" tabindex="-1"><img src="https://cdn.weglot.com/flags/circle/nl.svg" width="24" height="24" role="none" alt="Dutch flag" class="wg-flag"></a></li></ul></aside>'
  $('.language_translator .wg-default').html(langHtml)

    setTimeout(()=>{
      console.log($('.weglot-container.wg-default:eq(1)'))
      $('.weglot-container.wg-default:eq(1)').hide();
    },2000)

    

  // $('.language_translator #weglot-language').click(function () {
  //   $('.language_translator #weglot-listbox').toggle();
  // })

    

    let langInterval = setInterval(()=>{
      let currentLang = Weglot.getCurrentLang();
      console.log("currentLang: ",currentLang)
      if(currentLang == 'en'){
        console.log("currentLang if: ",currentLang)
        $('#weglot-language').html('<img src="https://cdn.weglot.com/flags/circle/gb.svg" width="24" height="24" role="none" alt="English flag" class="wg-flag">')
        clearInterval(langInterval);
      }else{
        console.log("currentLang else: ",currentLang)
        $('#weglot-language').html('<img src="https://cdn.weglot.com/flags/circle/nl.svg" width="24" height="24" role="none" alt="Dutch flag" class="wg-flag">');
        $('#weglot-listbox li.wg-li').html('<a role="option" href="javascript:void(0)" id="weglot-language-en" tabindex="-1"><img src="https://cdn.weglot.com/flags/circle/gb.svg" width="24" height="24" role="none" alt="English flag" class="wg-flag"></a>')
        clearInterval(langInterval);
      }
    },1500)
    

  $('.my-wg-drop a#weglot-language').click(function(){
    $(this).parents('.language_translator').find('ul#weglot-listbox').toggle()
    $('.weglot_switcher.wg-mouse-click.country-selector:eq(1)').toggleClass('closed')
    $('.weglot_switcher.wg-mouse-click.country-selector:eq(1)').toggleClass('open')
    $('.weglot_switcher.wg-mouse-click.country-selector:eq(1)').toggleClass('weg-openup')
    $('.weglot_switcher.wg-mouse-click.country-selector:eq(1)').toggleClass('weg-openleft')
    $('.wg-default #weglot-listbox').toggleClass('show')
  })

  $(document).on('click','.my-wg-drop #weglot-listbox a',function () {
    let ulTag = $(this).parents('#weglot-listbox')
    let selectedLang = $(this).attr('id')
    // let currentLang = Weglot.getCurrentLang();

    if(selectedLang === 'weglot-language-nl'){
      $('.wg-default .weglot_switcher.wg-mouse-click').attr('aria-label','Language selected: Dutch')
      $('.wg-default .wgcurrent').removeClass('en')
      $('.wg-default .wgcurrent').addClass('nl')
      $('.wg-default .wgcurrent').attr('data-l','nl')
      $('.wg-default .wgcurrent a').attr('id','weglot-language-nl')
      $('.wg-default .wgcurrent a').empty().html('<img src="https://cdn.weglot.com/flags/circle/nl.svg" width="24" height="24" role="none" alt="Dutch flag" class="wg-flag">')
      $('.wg-default .weglot_switcher #weglot-listbox li').removeClass('nl')
      $('.wg-default .weglot_switcher #weglot-listbox li').addClass('en')
      $('#weglot-language').html('<img src="https://cdn.weglot.com/flags/circle/nl.svg" width="24" height="24" role="none" alt="Dutch flag" class="wg-flag">');
      $('.wg-default .weglot_switcher #weglot-listbox li').html(`<a role="option" href="#" id="weglot-language-en" tabindex="-1"><img src="https://cdn.weglot.com/flags/circle/gb.svg" width="24" height="24" role="none" alt="English flag" class="wg-flag"></a>`)
      $(ulTag).html(`<li data-l="en" role="none" id="wg-en" class="wg-li en wg-flags"><a role="option" href="javascript:void(0)" id="weglot-language-en" tabindex="-1"><img src="https://cdn.weglot.com/flags/circle/gb.svg" width="24" height="24" role="none" alt="English flag" class="wg-flag"></a></li>`)
      console.log("dutch")
      Weglot.switchTo('nl');
    }else{
      $('.wg-default .weglot_switcher.wg-mouse-click').attr('aria-label','Language selected: English')
      $(ulTag).html(`<li data-l="nl" role="none" id="wg-nl" class="wg-li nl wg-flags"><a role="option" href="javascript:void(0)" id="weglot-language-nl" tabindex="-1"><img src="https://cdn.weglot.com/flags/circle/nl.svg" width="24" height="24" role="none" alt="Dutch flag" class="wg-flag"></a></li>`)
      Weglot.switchTo('en');
      $('#weglot-language').html('<img src="https://cdn.weglot.com/flags/circle/gb.svg" width="24" height="24" role="none" alt="English flag" class="wg-flag">')
    }
  })


//   var apiUrl = 'https://cdn-api-weglot.com/translate';
// var apiKey = 'wg_00ee18463c7e9a4315c6c98e5917ff376';
// var version = '1704710727';

// var requestData = {
//     api_key: apiKey,
//     v: version
// };

// $.ajax({
//     url: apiUrl,
//     method: 'POST',
//     data: requestData,
//     success: function(response) {
//         console.log('API Call Successful');
//         console.log(response);
//     },
//     error: function(xhr, status, error) {
//         console.error('API Call Failed');
//         console.error(status, error);
//     }
// });

  
});


